import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { HomepageProvider } from '../context/HomepageContext'
import HeroSlider from '../components/home/HeroSlider'
import HomeSections from '../components/home/HomeSections'
import AccreditationsStrip from '../components/home/AccreditationsStrip'
import PageMeta from '../components/seo/PageMeta'
import SocialSidebar from '../components/home/SocialSidebar'

export default function Home() {
  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    if (location.hash === '#programs') {
      navigate('/programs', { replace: true })
    }
  }, [location.hash, navigate])

  return (
    <HomepageProvider>
      <PageMeta
        title="Home"
        description="Mayar International Schools — bilingual K–12 education across Amman with British, American, and National programs."
        path="/"
      />
      <SocialSidebar />
      <HeroSlider />
      <HomeSections />
      <AccreditationsStrip />
    </HomepageProvider>
  )
}
